export default "__VITE_ASSET__BWDx$R1x__"